import { create } from 'zustand';

/**
 * Post Modal Store
 * Manages the state for the PostModal component across the app
 */
export const usePostModalStore = create((set) => ({
  // State
  post: null,
  isOpen: false,
  info: null,

  setInfo: (info) =>
    set({
      info,
    }),

  // Actions
  openModal: (post, info = null) =>
    set({
      post,
      isOpen: true,
      info,
    }),

  closeModal: () =>
    set({
      post: null,
      isOpen: false,
      info: null,
    }),

  setPost: (post) =>
    set({
      post,
    }),
}));
